var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentOrLoading',{staticStyle:{"min-height":"600px"}},[(_vm.event)?_c('LayoutSports',{attrs:{"event":_vm.event,"event_id":_vm.event_id,"sesion_id":_vm.sesion_id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }